module.exports = __webpack_public_path__ + "media/images/places/praca-marielle-franco-c661cbb3a8b8963383b2aea85b2a9a1e.jpg";